// Payroll State

export default {
  payrollList: [],
  payrollInfo: {}
}
